import { useState, useEffect } from "react";
import { Grid, Box, MenuItem } from '@mui/material';
import { TextField } from '@mui/material';
import MainCard from './MainCard';
import { gridSpacing } from '../../store/constant';
import axios from "../../components/axios";
import { useNavigate, useParams } from 'react-router-dom';


const ModifyUserForm = () => {
    const navigate = useNavigate();
    const { uuid } = useParams();

    const roles = [
      {
        value: '1',
        label: 'Admin',
      },
      {
        value: '2',
        label: 'Engineer',
      },
    ];

    const styleButton = {
        marginTop: "40px",
        backgroundColor: "#406599",
        color: "#fff",
        border: 0,
        borderRadius: "5px",
        boxSizing: "border-box",
        width: "120px",
        padding: "15px",
        fontSize: "18px",
        fontFamily: '"Roboto", "sans-serif"',
      };

    const [email, setEmail] = useState("");
    function handleEmail(e) {
        setEmail(e.target.value);
    }

    const [role, setRole] = useState("2");
    function handleRole(e) {
        setRole(e.target.value);
    }

    useEffect(() => {
      const getUserInfo = async () => {
        try {
          var input_data = JSON.stringify({ uuid: uuid });
          const response = await axios.post("/peloton/v1/users/user-info", input_data, { withCredentials: true});
          if (response.data.message === "success"){
            setEmail(response.data.user.name);
            if (response.data.user.role === "admin"){
              setRole('1');
            }else{
              setRole('2');
            }
          }
        } catch (error) {
            if (error.response.status !== null){
                if (error.response.status === 401){
                    alert(error.response.data.message);
                    navigate("/");
                }else{
                    console.log('error.response.status: ', error.response.status)
                    console.log('error.response.message: ', error.response.data.message)
                }
            }else{
                console.log(error);
            }
        }
    };
    getUserInfo();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [ uuid ]);

    const handleEditUser = async () => {
        var input_data = JSON.stringify({ email: email, role: role });

        axios.post("/peloton/v1/users/modify-user",input_data,{withCredentials: true})
        .then(response => {
            if (response.data.message === "success") {
              navigate("/user-list");
            }else{
                alert(response.data.message);
            }
        }).catch(function(err){
          if (!err.response){
            alert(err);
          }else{
            if (err.response.status === 401){
              alert(err.response.data.message);
              navigate("/");
            }else{
                console.log('error.response.status: ', err.response.status)
                console.log('error.response.status: ', err.response.data.message)
                alert(err.response.data.message)
            }
          }
        })
    }

    return (
    <MainCard title="Modify QBarn User">
        <Box sx={{ maxWidth: '100%'}}>
        <Grid container spacing={gridSpacing} rowSpacing={gridSpacing} columnSpacing={gridSpacing}>
        <Grid item xs={4}>
        <TextField
              required
              fullWidth
              id="user-email"
              label="User Email"
              value={email}
              onChange={handleEmail}
              variant="filled"
          />
          </Grid>
          <Grid item xs={4}>
            <TextField
              id="user-role"
              select
              fullWidth
              label="Select Role"
              value={role}
              onChange={handleRole}
              variant="filled"
            >
              {roles.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </TextField>
          </Grid>
          </Grid>
          <Grid container spacing={gridSpacing} justifyContent="flex-end">
          <Grid item>
          <button style={styleButton} onClick={handleEditUser}>Send</button>
          </Grid>
          </Grid>
          </Box>
      </MainCard>
    );
};

export default ModifyUserForm;
